import * as types from '../../actions/actionTypes';
import {MANUAL_CALCULATION_ROW_TYPES} from "../../bvcomponents/sqft/constants";
import sqftConfig from "../../bvcomponents/sqft/components/canvas/store/sqftConfig";

export const DEFAULT_MANUAL_CALC_ROW = {
  id: "",
  length: sqftConfig.getMeasureUnitPostfix(),
  height: sqftConfig.getMeasureUnitPostfix(),
  width: sqftConfig.getMeasureUnitPostfix(),
  selectedFeature: "",
  isShowTypesList: false,
};

export const getEdgesPlaceholder = () => {
  return sqftConfig.measureUnit === "Imperial"
    ? sqftConfig.edgeHeightImperial //+ sqftConfig.getMeasureUnitPostfix()
    : sqftConfig.edgeHeightMetric //+ sqftConfig.getMeasureUnitPostfix()
}

export const getDefaultManualCalcRowEdge = () => Object.assign({}, DEFAULT_MANUAL_CALC_ROW, { height: getEdgesPlaceholder() })

export const getInitialManualCalcRows = () => {
  return {
    [MANUAL_CALCULATION_ROW_TYPES.countertopRows]: new Array(6).fill(null)
      .map((value, index) => ({...DEFAULT_MANUAL_CALC_ROW, id: index + 1})),
    [MANUAL_CALCULATION_ROW_TYPES.edgeRows]: new Array(6).fill(null)
      .map((value, index) =>  ({...getDefaultManualCalcRowEdge(), id: index + 1})),
    [MANUAL_CALCULATION_ROW_TYPES.backsplashRows]: new Array(6).fill(null)
      .map((value, index) =>  ({...DEFAULT_MANUAL_CALC_ROW, id: index + 1})),
  }
}

const initialState = {
  showManualCalculation: false,
  switcherPosition: {
    rect: {x:0, y:0}
  },
  ...getInitialManualCalcRows()
};

export default function (state = initialState, action) {
  let filteredRows,
    newRow,
    lastRow,
    lastRowId;

  switch (action.type) {
    case types.TOGGLE_SHOW_MANUAL_CALCULATION:
    case types.SET_SWITCHER_POSITION:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.UPDATE_MANUAL_CALCULATION_ROWS:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.ADD_MANUAL_CALCULATION_ROW:
      lastRow = state[action.payload.type][state[action.payload.type].length - 1];
      lastRowId = lastRow ? lastRow.id : 0;
      switch (action.payload.type) {
        case MANUAL_CALCULATION_ROW_TYPES.edgeRows:
          newRow = {...getDefaultManualCalcRowEdge(), id: lastRowId + 1};
          break;
        default:
          newRow = {...DEFAULT_MANUAL_CALC_ROW, id: lastRowId + 1};
      }

      return {
        ...state,
        [action.payload.type] : [...state[action.payload.type], newRow]
      };
    case types.DELETE_MANUAL_CALCULATION_ROW:
      filteredRows = state[action.payload.type].filter((row) => row.id !== action.payload.id);

      return Object.assign({}, state, {
        [action.payload.type]: filteredRows
      });
    case types.UPDATE_MANUAL_CALCULATION_ROW: {
      const newList = state[action.payload.type].map((item) => {
        if (item.id === action.payload.row.id) {

          return Object.assign({}, item, {
            ...action.payload.updatedRowValue
          });
        }

        return item;
      });
      return Object.assign({}, state, {
        [action.payload.type]: newList
      });
    }

    default:
      return state
  }
}
